/** HTTP input types for HTTP requests.
    @readonly
    @enum {string}
*/
export var HTTPINPUTTYPE;
(function (HTTPINPUTTYPE) {
    HTTPINPUTTYPE["HIDDEN"] = "HIDDEN";
    HTTPINPUTTYPE["BUTTON"] = "BUTTON";
    HTTPINPUTTYPE["COLOR"] = "COLOR";
    HTTPINPUTTYPE["FIELDSET"] = "FIELDSET";
    HTTPINPUTTYPE["INPUT"] = "INPUT";
    HTTPINPUTTYPE["TEXT"] = "TEXT";
    HTTPINPUTTYPE["EMAIL"] = "EMAIL";
    HTTPINPUTTYPE["TEL"] = "TEL";
    HTTPINPUTTYPE["PASSWORD"] = "PASSWORD";
    HTTPINPUTTYPE["TEXTAREA"] = "TEXTAREA";
    HTTPINPUTTYPE["NUMBER"] = "NUMBER";
    HTTPINPUTTYPE["CHECKBOX"] = "CHECKBOX";
    HTTPINPUTTYPE["RADIO"] = "RADIO";
    HTTPINPUTTYPE["RANGE"] = "RANGE";
    HTTPINPUTTYPE["IMAGE"] = "IMAGE";
    HTTPINPUTTYPE["SELECT"] = "SELECT";
    HTTPINPUTTYPE["SELECTONE"] = "SELECT-ONE";
    HTTPINPUTTYPE["SELECTMANY"] = "SELECT-MANY";
    HTTPINPUTTYPE["DATE"] = "DATE";
    HTTPINPUTTYPE["TIME"] = "TIME";
    HTTPINPUTTYPE["URL"] = "URL";
    HTTPINPUTTYPE["DATETIME"] = "DATETIME";
    HTTPINPUTTYPE["DATETIMELOCAL"] = "DATETIME-LOCAL";
    HTTPINPUTTYPE["MONTH"] = "MONTH";
    HTTPINPUTTYPE["WEEK"] = "WEEK";
    HTTPINPUTTYPE["FILE"] = "FILE";
    HTTPINPUTTYPE["SEARCH"] = "SEARCH";
    HTTPINPUTTYPE["RESET"] = "RESET";
    HTTPINPUTTYPE["SUBMIT"] = "SUBMIT";
})(HTTPINPUTTYPE || (HTTPINPUTTYPE = {}));
;
